module.exports = __webpack_public_path__ + "static/media/Robotobold.7bf74824.woff";